<template>
	<div>
		<!-- 4 -->
		<svg class="bottle" x="0px" y="0px" viewBox="0 0 60 70">
			<g>
				<path class="st0" d="M43.81,31.15c-0.1-0.65-0.31-1.28-0.63-1.9c-0.88-1.76-2.61-3.36-4.99-4.58l-4-2.04l-0.01-0.01l0.06-0.55
		l0.03-0.32l0.13-1.08l0.67-6.19h0.01l-0.01-0.01l0.02-0.17l0.11-0.99l0.01-0.08l0.18-1.59l0.02-0.21l0.06-0.56h-5.39l0,0H24.7
		l1.23,11.77l-4.03,2.05c-0.02,0-0.03,0.01-0.03,0.01c-3.83,1.94-5.94,4.83-5.74,7.82l0.15,2.17v0.01l0.81,11.6v0.01l1.55,22.27
		c0.06,0.78,1.13,1.4,2.43,1.4l8.88,0.01l0,0h1.59L38.4,70c1.3,0,2.37-0.61,2.43-1.39l0.03-0.39l0.77-9.12v-0.01l0.5-5.95
		l1.48-17.67l0.18-2.1l0.07-0.8C43.9,32.09,43.89,31.62,43.81,31.15z M29.95,66.82l-0.01,3.1l0.02-9.21v1.49L29.95,66.82z
		M29.97,56.05v-0.61V56.05L29.97,56.05z M29.99,46.15v-0.44l0,0V46.15z" />
				<polygon class="st1" points="36.25,11.43 35.45,14.48 24.35,14.47 23.68,11.42" />

				<path class="st2" d="M21.61,32.6c0,0,2.05-7.29,10.13-8.08c8.08-0.79,11.06,5.71,11.05,8.1s-0.91,9.62-0.91,9.62
		s0.52-9.72-1.42-10.88s-5.05-0.82-10.54-0.69C24.58,30.79,21.61,32.6,21.61,32.6z" />
				<path class="st3"
					d="M28.62,31.81l7.58,0.01l-1.23,25.06h-1.64c0,0-0.62-22.47-0.61-23.53C32.72,32.28,28.62,31.81,28.62,31.81z" />
				<polygon class="st3" points="40.87,68.21 40.39,68.3 40.69,61.28 41.78,35.46 41.79,35.46 42.7,34.51 42.84,34.36 43.8,33.37 
		43.81,33.35 43.63,35.48 42.14,53.13 41.64,59.08 41.64,59.09 	" />
				<path class="st4" d="M35.06,14.48l-10-0.01l0.1,0.96l1.14,0.13l0.5,7.06c0,0-6.2,1.97-8.28,7.25c-1.69,4.29,2.54,40.09,2.54,40.09
		h6.13c0,0-1.56-36.44-0.67-39.76c0.89-3.31,2.67-7.59,2.67-7.59l-0.32-5.88L35.06,14.48z" />

				<polygon class="st5" points="31.68,16.3 34.4,15 33.03,22.36 31.64,22.24 	" />

				<polygon class="st6" points="33.03,11.64 35.45,11.64 35.06,14.1 32.76,13.93 	" />
				<polygon class="st4" points="25.02,14.09 24.68,11.63 29.11,11.64 28.66,14.09 	" />
				<polygon class="st7"
					points="35.06,14.48 34.18,22.63 33.34,22.54 34.31,15.05 34.36,14.74 34.41,14.48 	" />
				<polygon class="st7"
					points="36.25,11.43 35.45,14.48 35.06,14.48 35.08,14.31 35.31,12.51 35.38,11.64 35.46,10.87 	" />
				<path class="st8" d="M25.68,31.16l1.51,38.82h4.35l0.67-39.38C32.2,30.6,27.53,30.06,25.68,31.16z" />
			</g>
		</svg>
	</div>
</template>

<script>
  export default {
    name: 'bottle4'
  }
</script>

<style scoped>
.bottle {
	position: fixed;
	height: 20vh;
	top: 40vh;
	left: 45vw;
	animation: text-shadow 1.5s ease-in-out infinite;
	animation-delay: .1s;
}

@keyframes text-shadow {
    0% {  
        transform: translateY(0);
		filter: drop-shadow(0 0 9px #333);
    }

    25% {  
        transform: translateY(-0.5em);
		filter: drop-shadow(0 0 9px #333);
    }

    50% {  
        transform: translateY(0.5em);
		filter: drop-shadow(0 0 18px #91bd09);
    }
    
   75% {
        transform: translateY(-0.25em);
		filter: drop-shadow(0 0 9px #333);
    }

    100% {  
        transform: translateY(0);
		filter: drop-shadow(0 0 9px #333);
    }
}
	
.st0{fill:#4F9F00;}
	.st1{fill:#571123;}
	.st2{opacity:0.62;fill:#313131;}
	.st3{opacity:0.55;fill:#FFF6D6;}
	.st4{opacity:0.53;fill:#7A1D23;}
	.st5{opacity:0.62;fill:#313131;}
	.st6{opacity:0.62;fill:#313131;}
	.st7{fill:#FFF6D6;}
	.st8{opacity:0.2;fill:#FFF6D6;}
</style>
